import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconZap: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconZap"><Path d="M19.7978 8.75H13.75C13.4739 8.75 13.25 8.52614 13.25 8.25V2.3557C13.25 1.86505 12.6169 1.66792 12.3384 2.07183L3.7906 14.4661C3.56185 14.7978 3.79928 15.25 4.2022 15.25H10.25C10.5261 15.25 10.75 15.4739 10.75 15.75V21.6443C10.75 22.135 11.383 22.3321 11.6616 21.9282L20.2094 9.53387C20.4382 9.20218 20.2007 8.75 19.7978 8.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconZap;
